import {
  IBrandDimension,
  MeasureTransformMap,
} from '@principle-theorem/reporting/interfaces';
import { QueryOptionResolver } from '../../query-option-resolvers';
import { BaseDimensionMeasures } from '../base-measures';
import { MeasurePath } from '../data-accessor-factory';
import { CanBeChartedProperty, CanDoAllProperty } from '../measure-properties';
import { MeasurePropertyFactory } from '../measure-property-factory';

export class BrandDimensionMeasures
  extends BaseDimensionMeasures
  implements MeasureTransformMap<Pick<IBrandDimension, 'name'>>
{
  get ref(): CanBeChartedProperty {
    const propertyName = 'ref';
    const ref = this.measureRef(MeasurePath.docRef(propertyName));
    return MeasurePropertyFactory.docRef(
      {
        id: this._pathWithPrefix(propertyName),
        label: 'Brand Ref',
        optionResolver: QueryOptionResolver.brands(),
        availableAsColumn: false,
        availableAsChart: false,
      },
      ref,
      this.buildQuery().attributes([ref.attributePath]).get()
    );
  }

  get name(): CanDoAllProperty {
    const propertyName = 'name';
    const name = this.measureRef(propertyName);
    const docRef = this.measureRef(MeasurePath.docRef('ref'));
    return MeasurePropertyFactory.docRef(
      {
        id: this._pathWithPrefix(propertyName),
        label: 'Brand Name',
        summary: `The name of the brand that the practice belongs to. For multi-practice workspaces, this can be used to aggregate a data point across all practices.`,
        optionResolver: QueryOptionResolver.brands(),
      },
      docRef,
      this.buildQuery()
        .attributes([docRef.attributePath, name.attributePath])
        .get(),
      name
    );
  }

  get recallPeriodInMonths(): CanDoAllProperty {
    const propertyName = 'settings.recalls.periodInMonths';
    const measure = this.measureRef(propertyName);
    return MeasurePropertyFactory.number(
      {
        id: this._pathWithPrefix(propertyName),
        label: 'Recall Period (Months)',
        summary: `The number of months between patient recalls for this brand.`,
      },
      measure,
      this.buildQuery().attributes([measure.attributePath]).get()
    );
  }

  get secondaryRecallPeriodInMonths(): CanDoAllProperty {
    const propertyName = 'settings.secondaryRecalls.periodInMonths';
    const measure = this.measureRef(propertyName);
    return MeasurePropertyFactory.number(
      {
        id: this._pathWithPrefix(propertyName),
        label: 'Secondary Recall Period (Months)',
        summary: `The number of months between patient secondary recalls for this brand.`,
      },
      measure,
      this.buildQuery().attributes([measure.attributePath]).get()
    );
  }
}
